/* esm.sh - @radix-ui/react-slot@1.2.4 */
export * from "/*@radix-ui/react-slot@1.2.4/esnext/react-slot.mjs";
